import { useMutation } from '@tanstack/react-query';

import type { MutationResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useArchiveCatalogCertificateMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<MutationResponse>({ method: 'PUT', url }),
  });

export const useReorderCatalogCertificateMutation = (url: string) =>
  useMutation({
    mutationFn: (ids: number[]) =>
      HttpClient.request<MutationResponse>({
        method: 'PUT',
        url,
        data: { ids },
      }),
  });
